import styled from '@emotion/styled'
import { Tooltip } from '@mui/material'
import React from 'react'

export function InputCheckBox(props) {
    let { className, value, name, placeholder, onChangeHandler, errorMessage, required, errors } = props
    const onCheck = (e, errorMessage) => {
        const val = e.target.checked ? "true" : ''
        const event = {
            target: {
                name: e?.target?.name,
                value: val,
                required: true
            }
        }
        onChangeHandler(event, errorMessage)
    }

    const TextOnlyTooltip = styled(({ className, open, ...props }) => (
        <Tooltip {...props} open={open} componentsProps={{ tooltip: { className: className } }} />
    ))(`     
          margin-left: 3px;
          color: black;
          background-color: #EDECEC;
      `);

    return (
        <div className={`px-1 pt-1 ${className} `}>
            <div className='flex items-center mt-2' >
                <TextOnlyTooltip open={errors?.[name] ? true : false} title={
                    <div className="text-12F" >Please check terms and conditions</div>
                } arrow>
                    <input className='p-1 w-4 h-4 cursor-pointer' type="checkbox" checked={value === "true" ? true : false} required={required} value={value} name={name} onChange={(event) => { onCheck(event, errorMessage) }} onBlur={(event) => { onCheck(event.target.checked, errorMessage) }} placeholder={placeholder} />
                </TextOnlyTooltip>
                {placeholder}
            </div>
        </div>
    )
}
